import React, { useState } from 'react';
import { Auth } from 'aws-amplify';
import HGForm from 'components/HGForm';
import { Button } from 'components/shadcn/ui/button';

const ResetPassword = ({ maskedUsername, username, triggerConfirmation }) => {
    const [errorMessage, setErrorMessage] = useState(null);
    const handleResetPassword = async (creds) => {
        setErrorMessage(null);
        try {
            const passwordReset = await Auth.forgotPasswordSubmit(
                username,
                creds.code,
                creds.password
            );
            if (passwordReset === 'SUCCESS') {
                triggerConfirmation();
            }
        } catch (error) {
            setErrorMessage(error.message);
            console.log(error);
        }
    };
    const resendCode = async (username) => {
        setErrorMessage(null);
        try {
            const resent = await Auth.forgotPassword(username);
            console.log(resent);
            if (resent) {
                console.log('Confirmation code resent successfully');
            }
        } catch (error) {
            console.log('Error resending confirmation code: ', error);
            setErrorMessage(error.message);
        }
    };
    return (
        <>
            <h5 className="mb-3 text-center text-base font-medium text-foreground">
                Reset Password
            </h5>
            <p className="mb-5 text-sm font-light text-foreground">
                Enter the code that was sent to your email{' '}
                <strong>{maskedUsername}</strong> below along with your new
                password.
            </p>
            <HGForm
                fields={{
                    code: 'Code',
                    password: 'New Password',
                    confirmPassword: 'Confirm Password',
                }}
                handleSubmit={handleResetPassword}
                buttonText="Reset Password"
                errorMessage={errorMessage}
            />
            <Button
                onClick={() => resendCode(username)}
                variant="link"
                className="mx-auto block w-max font-light text-foreground"
            >
                <span>resend code</span>
            </Button>
        </>
    );
};

export default ResetPassword;
